import React from "react";

const colorForScore = (s) => (s < 30 ? "#FF3B30" : s < 70 ? "#FFCC00" : "#34C759");

function Bar({ label, score, weight, sub }) {
  const c = colorForScore(score);
  return (
    <div className="border-t border-white/10 py-3" data-testid={`breakdown-${label.toLowerCase()}`}>
      <div className="flex items-center justify-between mb-2">
        <div className="overline">{label} <span className="text-white/40">· {Math.round(weight * 100)}%</span></div>
        <div className="mono text-sm" style={{ color: c }}>{Math.round(score)}</div>
      </div>
      <div className="h-1.5 w-full bg-white/5 relative">
        <div className="h-full transition-all duration-500" style={{ width: `${Math.max(2, score)}%`, background: c }} />
      </div>
      {sub && <div className="mt-2 text-xs text-white/50 mono">{sub}</div>}
    </div>
  );
}

export default function SentimentBreakdown({ breakdown }) {
  if (!breakdown) return null;
  const t = breakdown.technical || {};
  const m = breakdown.momentum || {};
  const n = breakdown.news || {};
  const v = breakdown.volatility || {};
  return (
    <div className="bg-surface border border-white/10 p-5" data-testid="sentiment-breakdown">
      <div className="flex items-center justify-between mb-1">
        <h3 className="heading text-lg font-semibold">Sentiment Breakdown</h3>
        <span className="overline">composite weights</span>
      </div>
      <Bar label="Technical" score={t.score || 0} weight={t.weight || 0.4} sub="RSI · MA Cross · MACD" />
      <Bar label="Momentum" score={m.score || 0} weight={m.weight || 0.2} sub="Price Change · Volume" />
      <Bar
        label="News"
        score={n.score || 0}
        weight={n.weight || 0.3}
        sub={n.count ? `${n.positive || 0}↑ · ${n.neutral || 0}= · ${n.negative || 0}↓ · ${n.count} headlines` : "No headlines yet"}
      />
      <Bar label="Volatility" score={v.score || 0} weight={v.weight || 0.1} sub={v.vix ? `VIX ${v.vix.toFixed(2)}` : "Volatility proxy"} />
    </div>
  );
}
